import { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { baseApi } from '../../api/api';

export default function ContactFormModal({ open, onClose }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error('필수 항목을 모두 입력해주세요.');
      return;
    }
    setSending(true);
    try {
      const { data } = await axios.post(`${baseApi}/contact`, form);
      toast.success(data.message || '문의가 접수되었습니다.');
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || '문의 전송에 실패했습니다.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h3 style={styles.title}>문의하기</h3>
          <button style={styles.closeBtn} onClick={onClose}><CloseIcon sx={{ fontSize: 20 }} /></button>
        </div>
        <p style={styles.desc}>궁금하신 점이나 서비스 관련 문의를 남겨주세요.</p>

        <div style={styles.row}>
          <div style={styles.fieldHalf}>
            <label style={styles.label}>이름 *</label>
            <input style={styles.input} value={form.name} onChange={set('name')} placeholder="홍길동" />
          </div>
          <div style={styles.fieldHalf}>
            <label style={styles.label}>이메일 *</label>
            <input style={styles.input} type="email" value={form.email} onChange={set('email')} placeholder="you@email.com" />
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.fieldHalf}>
            <label style={styles.label}>전화번호</label>
            <input style={styles.input} value={form.phone} onChange={set('phone')} placeholder="010-0000-0000" />
          </div>
          <div style={styles.fieldHalf}>
            <label style={styles.label}>제목 *</label>
            <input style={styles.input} value={form.subject} onChange={set('subject')} placeholder="문의 제목" />
          </div>
        </div>
        <div style={styles.field}>
          <label style={styles.label}>내용 *</label>
          <textarea style={styles.textarea} rows={4} value={form.message} onChange={set('message')} placeholder="문의 내용을 작성해주세요." />
        </div>

        <button style={{ ...styles.submitBtn, opacity: sending ? 0.6 : 1 }} onClick={handleSubmit} disabled={sending}>
          <SendIcon sx={{ fontSize: 16, mr: 0.5 }} />
          {sending ? '전송 중...' : '문의 보내기'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 10000,
  },
  modal: {
    background: '#fff', borderRadius: 16, padding: '28px 32px', width: '100%', maxWidth: 480,
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)', position: 'relative',
  },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 },
  title: { margin: 0, fontSize: 20, fontWeight: 700, color: '#1a1a2e' },
  closeBtn: {
    background: 'none', border: 'none', cursor: 'pointer', color: '#999', padding: 4,
    borderRadius: 6, display: 'flex',
  },
  desc: { fontSize: 13, color: '#888', marginTop: 0, marginBottom: 20 },
  row: { display: 'flex', gap: 12, marginBottom: 14 },
  field: { marginBottom: 14 },
  fieldHalf: { flex: 1 },
  label: { display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 },
  input: {
    width: '100%', height: 40, border: '1.5px solid #e0e0ef', borderRadius: 8,
    padding: '0 12px', fontSize: 13, color: '#222', background: '#fafafa',
    outline: 'none', boxSizing: 'border-box',
  },
  textarea: {
    width: '100%', border: '1.5px solid #e0e0ef', borderRadius: 8,
    padding: '10px 12px', fontSize: 13, color: '#222', background: '#fafafa',
    outline: 'none', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit',
  },
  submitBtn: {
    width: '100%', height: 44, background: '#551FFF', color: '#fff', border: 'none',
    borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    boxShadow: '0 4px 14px rgba(85,31,255,0.3)', marginTop: 4,
  },
};
